export default __webpack_public_path__ + "static/media/BQ.77d77a60.svg";